import { gql } from '__generated__';

export default gql(`
  mutation DuplicateTicketNumberSequence($input: EditTicketNumberSequenceInput!) {
    duplicateTicketNumberSequence(input: $input) {
      id
    }
  }
`);
